// extracted by mini-css-extract-plugin
export default {"title":"catalog_title__bSYOK"};